import React, { useEffect, useState } from "react";
import { getRecords, saveRecords } from "../../../services/api.service";
import { ChevronDown, ChevronRight } from "react-feather";
import { useNavigate } from "react-router-dom";
// import Loader from "../../../components/common/CustomLoader/Loader";
// import CustomModal from "../../../components/common/CustomModal/CustomModal";
// import { useCustomAlert } from "../../../components/common/CustomModal/useCustomAlert";

const MenusOptionsList = ({ roleId }) => {
  const [menuData, setMenuData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMenus, setSelectedMenus] = useState([]);
  const [expandedMenus, setExpandedMenus] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const navigate = useNavigate();
  // const { alertState, showAlert, closeAlert } = useCustomAlert();

  const getMenuData = async (roleId) => {
    try {
      const schema = localStorage.getItem("schema");
      // console.log({roleId})
      const payload = {
        "modelName": "menu_access_masters",
        "schema": schema,

        "attributes": [
          "id",
          "role_id",
          "menu_id",
          "access",
          "is_active",
          "created_by",
          "updated_by",
          "createdAt",
          "updatedAt"
        ],

        "include": [
          {
            "model": "menu_masters",
            "as": "menu",
            "attributes": ["id", "menu_name", "menu_url", "parent_id", "is_child"]
          },
          {
            "model": "role_masters",
            "as": "role",
            "attributes": ["id", "role_name"]
          },
          {
            "model": "user_masters",
            "as": "created_by_user",
            "attributes": ["id", "username", "email_id"]
          },
          {
            "model": "user_masters",
            "as": "updated_by_user",
            "attributes": ["id", "username", "email_id"]
          }
        ],

        "whereCondition": {},

        "pagination": {
          "page": 1,
          "limit": 20
        },

        "orderCondition": [
          ["id", "DESC"]
        ]
      }


      const response = await getRecords(payload, "/getRecords");
      return response.data || [];
    } catch (error) {
      console.error("Error fetching menu data:", error);
      return [];
    }
  };

  // Function to extract menu IDs with hasAccess: true
  const getAccessibleMenuIds = (menus) => {
    let accessibleIds = [];
    menus.forEach(menu => {
      if (menu.access) {
        accessibleIds.push(menu.id);
      }
      if (menu.childMenus && menu.childMenus.length > 0) {
        accessibleIds = [...accessibleIds, ...getAccessibleMenuIds(menu.childMenus)];
      }
    });
    return accessibleIds;
  };

  useEffect(() => {
    const fetchData = async () => {
      if (roleId) {
        setLoading(true);
        try {
          const data = await getMenuData(roleId);
          setMenuData(data);
          console.log("data ", data)
          // Initialize selected menus based on hasAccess
          const accessibleMenuIds = getAccessibleMenuIds(data);
          setSelectedMenus(accessibleMenuIds);
        } catch (error) {
          console.error("Error loading data:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchData();
  }, [roleId]);

  const toggleMenu = (menuId) => {
    setExpandedMenus(prev =>
      prev.includes(menuId)
        ? prev.filter(id => id !== menuId)
        : [...prev, menuId]
    );
  };

  const getAllChildMenuIds = (menu) => {
    let ids = [];
    if (menu.childMenus && menu.childMenus.length > 0) {
      menu.childMenus.forEach(child => {
        ids.push(child.id);
        ids = [...ids, ...getAllChildMenuIds(child)];
      });
    }
    return ids;
  };

  const findParentIds = (menuId, menus, parentIds = []) => {
    for (const menu of menus) {
      if (menu.id === menuId) return parentIds;
      if (menu.childMenus && menu.childMenus.length > 0) {
        const found = findParentIds(menuId, menu.childMenus, [...parentIds, menu.id]);
        if (found) return found;
      }
    }
    return null;
  };

  const findMenuById = (menuId, menus) => {
    for (const menu of menus) {
      if (menu.id === menuId) return menu;
      if (menu.childMenus && menu.childMenus.length > 0) {
        const found = findMenuById(menuId, menu.childMenus);
        if (found) return found;
      }
    }
    return null;
  };

  // const handleCheckboxChange = (menu, isChecked) => {
  //   const allChildIds = getAllChildMenuIds(menu);
  //   const parentIds = findParentIds(menu.id, menuData) || [];

  //   setSelectedMenus(prev => {
  //     let newSelected = [...prev];

  //     // Handle current menu and its children
  //     if (isChecked) {
  //       newSelected = [...new Set([...newSelected, menu.id, ...allChildIds])];

  //       // Check parent menus
  //       parentIds.forEach(parentId => {
  //         const parentMenu = findMenuById(parentId, menuData);
  //         if (parentMenu) {
  //           const allChildIdsOfParent = getAllChildMenuIds(parentMenu);
  //           const allChildrenSelected = allChildIdsOfParent.every(id => 
  //             newSelected.includes(id)
  //           );

  //           if (allChildrenSelected && !newSelected.includes(parentId)) {
  //             newSelected.push(parentId);
  //           }
  //         }
  //       });
  //     } else {
  //       newSelected = newSelected.filter(id => id !== menu.id && !allChildIds.includes(id));

  //       // Uncheck parent menus if needed
  //       parentIds.forEach(parentId => {
  //         if (newSelected.includes(parentId)) {
  //           const parentMenu = findMenuById(parentId, menuData);
  //           if (parentMenu) {
  //             const allChildIdsOfParent = getAllChildMenuIds(parentMenu);
  //             const anyChildSelected = allChildIdsOfParent.some(id => 
  //               newSelected.includes(id)
  //             );

  //             if (!anyChildSelected) {
  //               newSelected = newSelected.filter(id => id !== parentId);
  //             }
  //           }
  //         }
  //       });
  //     }

  //     return newSelected;
  //   });
  // };
  const handleCheckboxChange = (menu, isChecked) => {
    const allChildIds = getAllChildMenuIds(menu);
    const parentIds = findParentIds(menu.id, menuData) || [];

    setSelectedMenus(prev => {
      let newSelected = [...prev];

      // Handle current menu and its children
      if (isChecked) {
        // Add current menu
        if (!newSelected.includes(menu.id)) {
          newSelected.push(menu.id);
        }

        // If it's a parent with children, select all children
        if (allChildIds.length > 0) {
          allChildIds.forEach(childId => {
            if (!newSelected.includes(childId)) {
              newSelected.push(childId);
            }
          });
        }

        // Select all parent menus
        parentIds.forEach(parentId => {
          if (!newSelected.includes(parentId)) {
            newSelected.push(parentId);
          }
        });
      } else {
        // Remove current menu
        newSelected = newSelected.filter(id => id !== menu.id);

        // If it's a parent, remove all children
        if (allChildIds.length > 0) {
          newSelected = newSelected.filter(id => !allChildIds.includes(id));
        }

        // Check parent menus in hierarchy
        let parentsToCheck = [...parentIds];

        while (parentsToCheck.length > 0) {
          const currentParentId = parentsToCheck.shift();
          const currentParent = findMenuById(currentParentId, menuData);

          if (currentParent) {
            const allChildrenOfParent = getAllChildMenuIds(currentParent);
            const anyChildrenSelected = allChildrenOfParent.some(id =>
              newSelected.includes(id)
            );

            if (!anyChildrenSelected && newSelected.includes(currentParentId)) {
              newSelected = newSelected.filter(id => id !== currentParentId);

              // Move up to check grandparents
              const grandParentIds = findParentIds(currentParentId, menuData) || [];
              parentsToCheck = [...parentsToCheck, ...grandParentIds];
            }
          }
        }
      }

      return newSelected;
    });
  };

  const isMenuSelected = (menuId) => selectedMenus.includes(menuId);
  const isMenuExpanded = (menuId) => expandedMenus.includes(menuId);

  const flattenMenuData = (menus) => {
    let flatMenus = [];
    menus.forEach(menu => {
      flatMenus.push(menu);
      if (menu.childMenus && menu.childMenus.length > 0) {
        flatMenus = [...flatMenus, ...flattenMenuData(menu.childMenus)];
      }
    });
    return flatMenus;
  };

  const handleSubmit = async () => {
    try {
      setSubmitLoading(true);
      const schema = localStorage.getItem("schema");
      const userId = localStorage.getItem("userId");

      // Prepare accessData array with all menus
      const accessData = flattenMenuData(menuData).map(menu => ({
        role_id: roleId,
        menu_id: menu.id,
        hasAccess: selectedMenus.includes(menu.id)
      }));

      const payload = {
        schema: schema,
        userId: parseInt(userId),
        accessData: accessData
      };

      const response = await saveRecords(payload, "/createOrUpdateMenuAccess");

      if (response?.code === 0) {
        // await showAlert({
        //   title: "Error",
        //   message: response?.message || "Failed to save menu access",
        //   icon: "error",
        //   confirmText: "OK",
        //   cancelText: "",
        // });
        return;
      }

      // await showAlert({
      //   title: "Success",
      //   message: "Menu access updated successfully!",
      //   icon: "success",
      //   confirmText: "",
      //   cancelText: "",
      // });

      navigate("/", { state: { refreshMenu: true } }); // Redirect after success

    } catch (error) {
      console.error("Error saving menu access:", error);
      // await showAlert({
      //   title: "Error",
      //   message: "Something went wrong. Please try again.",
      //   icon: "error",
      //   confirmText: "OK",
      //   cancelText: "",
      // });
    } finally {
      setSubmitLoading(false);
    }
  };

  const renderMenuTree = (menus, depth = 0, isSubmenu = false) => {
    return (
      <div className={`menu-level ${isSubmenu ? 'submenu' : ''}`}>
        {menus.map((menu) => (
          <div
            key={menu.id}
            className={`menu-item ${depth === 0 ? 'top-level' : ''}`}
            style={{ marginLeft: depth > 0 ? '20px' : '0' }}
          >
            <div
              className="d-flex align-items-center justify-content-between p-2 rounded menu-row"
              style={{
                backgroundColor: depth === 0 ? '#f8f9fa' : depth === 1 ? '#f1f8ff' : '#fff',
                borderLeft: depth > 0 ? '3px solid #dee2e6' : 'none',
                cursor: 'pointer'
              }}
              onClick={(e) => {
                if (!e.target.closest('.form-check, .form-check *')) {
                  toggleMenu(menu.id);
                }
              }}
            >
              <div className="d-flex align-items-center flex-grow-1">
                <div
                  className="form-check me-3"
                  onClick={(e) => e.stopPropagation()}
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={isMenuSelected(menu.id)}
                    onChange={(e) => handleCheckboxChange(menu, e.target.checked)}
                    id={`menu-${menu.id}`}
                  />
                  <label
                    className="form-check-label fw-medium"
                    htmlFor={`menu-${menu.id}`}
                    style={{ cursor: 'pointer' }}
                  >
                    {menu.menu_name}
                  </label>
                </div>
              </div>

              {menu.childMenus && menu.childMenus.length > 0 && (
                <div
                  className="expand-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleMenu(menu.id);
                  }}
                >
                  {isMenuExpanded(menu.id) ? (
                    <ChevronDown size={18} />
                  ) : (
                    <ChevronRight size={18} />
                  )}
                </div>
              )}
            </div>

            {menu.childMenus && menu.childMenus.length > 0 && isMenuExpanded(menu.id) && (
              <div className="child-menus mt-1">
                {renderMenuTree(menu.childMenus, depth + 1, true)}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      {/* <CustomModal
        isOpen={alertState.isOpen}
        onClose={closeAlert}
        title={alertState.title}
        message={alertState.message}
        icon={alertState.icon}
        confirmText={alertState.confirmText}
        cancelText={alertState.cancelText}
        resolve={alertState.resolve}
      /> */}
      <div className="menu-options-container">
        {(submitLoading || loading) && (
          // <Loader color="blue" size={60} blur={true} />
          <h1>Loading...</h1>
        )}
        <div className="card main-menu-card border-0 shadow-sm">
          <div className="card-body p-3">
            {menuData.length > 0 ? (
              renderMenuTree(menuData.filter(menu => ["Main Menu", "Admin & Insights"].includes(menu.menu_name)))
            ) : (
              <div className="text-center py-4">No menus found</div>
            )}
          </div>
        </div>

        <div className="text-center mt-4">
          <button
            className="btn btn-primary submit-button px-4 py-2 fw-medium"
            onClick={handleSubmit}
            disabled={submitLoading}
            style={{
              backgroundColor: submitLoading ? '#6c757d' : '#0d6efd',
              border: 'none',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
          >
            {submitLoading ? 'Saving...' : 'Save Menu Access'}
          </button>
        </div>
      </div>
    </>
  );
};

export default MenusOptionsList;